import { compose, replace } from 'lodash/fp';

import { PatternMask } from '../masked';

import { dateMatchableSymbols, DAY_SYMBOL, MONTH_SYMBOL, YEAR_SYMBOL } from './constants';
import { DateMaskInputProps } from './types';

export const createDateFormatPattern = compose(
    replace('yyyy', `${YEAR_SYMBOL.value}`.padEnd(4, YEAR_SYMBOL.value)),
    replace(/MM|M/, `${MONTH_SYMBOL.value}`.padEnd(2, MONTH_SYMBOL.value)),
    replace(/dd|d/, `${DAY_SYMBOL.value}`.padEnd(2, DAY_SYMBOL.value))
);

export const createNewDatePatternMask = ({ dateFormatPattern }: DateMaskInputProps) => {
    const patternMask = new PatternMask(dateFormatPattern, {
        matchableSymbols: dateMatchableSymbols,
        escapeCharacter: null,
    });

    return patternMask;
};
